import { EntityManager } from "@/components/EntityManager";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function Debtors() {
  return <EntityManager config={ENTITY_CONFIG.debtors} />;
}
